import * as CONSTANTS from './constants';
import { IReviewStoreState } from './Validation';

export const getInitialState = () => {
  return {
    dataLoading: false,
    isError: false,
    reviewData: {},
    tentativeInfo: {
      isLoading: false,
      isError: false,
      data: {}
    },
    goSafe: { data: {}, headerMsg: "", isLoading: false },
    goSafeSocial: { data: {}, headerMsg: "", isLoading: false },
    promocode: '',
    goCashSelected: false,
    tribeDetails: {
      errors: [],
      walletEarn: '',
      loyaltyEligible: false,
      tierName: '',
      messageTitle: '',
      messageText: '',
      iconUrl: '',
      cta: null,
      ctaLink: null,
      ctaActionType: null,
      textList: null,
      pendingStateMessage: null,
      walletMessage: null,
      walletStatus: false,
      ctaAction: null,
      tnc: null,
      iconColor: ''
    },
    showGoTribe: false,
    go_tribe:{}
  }
}

//TODO:- returning a new object each time with Object.assign instead of direct state manipulation
const Review = (state: IReviewStoreState = getInitialState(), action) => {
  const { type, actionData } = action;

  switch (type) {
    case CONSTANTS.TOGGLE_REVIEW_DATA_LOADING:
      const data = Object.assign({}, state);
      data.dataLoading = actionData.isLoading;
      data.isError = actionData.isError || false;
      data.reviewData = actionData.reviewData || {};

      return Object.assign({}, data);

    case CONSTANTS.UPDATE_TENTATIVE_ACTION:
      let tentativeInfo = Object.assign({}, state.tentativeInfo);
      tentativeInfo['isLoading'] = actionData.isLoading;
      tentativeInfo['error'] = actionData.error || false;
      tentativeInfo['data'] = actionData.data;


      return Object.assign({}, state, {
        ...state,
        tentativeInfo: tentativeInfo
      });

    case CONSTANTS.SET_GO_SAFE_DATA:
      let goSafe = Object.assign({}, state.goSafe);
      goSafe.data = actionData.data;
      goSafe.headerMsg = actionData.headerMsg;
      goSafe.isLoading = actionData.isLoading;

      return Object.assign({}, {
        ...state,
        goSafe
      })
    case CONSTANTS.SET_GO_SAFE_SOCIAL_DATA:
      let goSafeSocial = Object.assign({}, state.goSafeSocial);
      goSafeSocial.data = actionData.data;
      goSafeSocial.headerMsg = actionData.headerMsg;
      goSafeSocial.isLoading = actionData.isLoading;

      return Object.assign({}, {
        ...state,
        goSafeSocial
      })
    case CONSTANTS.SET_SELECTED_PROMO_CODE:

      return Object.assign({}, {
        ...state,
        promocode: actionData
      })
    case CONSTANTS.TOGGLE_GOCASH_SELECTION:

      return Object.assign({}, {
        ...state,
        goCashSelected: actionData
      })
    case CONSTANTS.UPDATE_GOTRIBE_DETAILS:
      return {
        ...state,
        tribeDetails: { ...action.tribeDetails.tribeData },
        showGoTribe: action.tribeDetails.showTribeData
      };
    case CONSTANTS.UPDATE_GOTRIBE:
      return {
        ...state,
        showGoTribe: action.showTribeData
      };
    default:
      return state;
  }
}

export default Review;
